<template>
    <div id="root">
        <Nav />
        <main>
            <router-view :key="$route.fullPath"></router-view>
        </main>
        <Footer v-if="showFooter"/>
    </div>
</template>

<script>
import Nav from "../components/Nav.vue";
import Footer from "../components/Footer";
import { mapState } from "vuex";
export default {
  components: {
    Nav,
    Footer
  },
  name: "App",
  computed: {
    ...mapState({
      isLoggedIn: (state) => state.auth.isLoggedIn,
    }),
    isInDashboard() {
      return this.isLoggedIn && this.$route.name == "dashboard";
    },
    mobile() {
      return window.screen.width <= 446;
    }
  },
  data() {
    return {
      showFooter: false
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(newVal) {
        const { name } = newVal;
        if (this.mobile) {
          return this.showFooter = name != "get-quote";
        }
        if (this.isLoggedIn) {
          return this.showFooter = name != "dashboard";
        }
        return this.showFooter = true;
      }
    }
  }
};
</script>
<style lang="scss">
@import "~@/style/_variables.scss";
body {
    font-family: $system-font;
}
</style>
